import React, {useState}                    from "react";
import { useDispatch }                      from "react-redux";
import classnames                           from 'classnames';

import { FontAwesomeIcon }                  from '@fortawesome/react-fontawesome';
import { faSearch }                         from '@fortawesome/free-solid-svg-icons';
import { faSpinner }                        from '@fortawesome/free-solid-svg-icons';
import { Modal }                            from 'react-bootstrap';
import Messages                             from "pu-react/components/Messages";
import Substitute                           from "./substitute/Substitute";

import { getSelectedPS }                    from "product_tabs/tab_parts/utils/helpers";
import { getSubstitutes }                   from "product_tabs/tab_parts/bomSlice";

const ShowMoreOptions = (props) => {

  const dispatch = useDispatch();
  const [exact_qty, setExactQty] = useState(0);

  const {
    bom_line_item,
    loading,
    markups,
    messages,
    selected_board_qty,
    substitutes,
    show,
    onHide,
    onReplacePartSupplier,
  } = props;

  if(!isManager) return null;

  const identifier = bom_line_item ? (bom_line_item.mpn || bom_line_item.distributor_part_number) : ""
  const selected_markup = markups && markups[selected_board_qty] ? markups[selected_board_qty] : 0
  const selected_ps = getSelectedPS(bom_line_item, selected_board_qty)

  const onShow = () => {
    if(!bom_line_item){
      onHide()
      return
    }

    setExactQty(bom_line_item.qty * selected_board_qty)
    dispatch(getSubstitutes(bom_line_item.id))
  }

  return (
    <Modal 
      className="show-more-options-modal" 
      show={show} 
      onHide={onHide}
      size="xl"
      onShow={onShow} 
      centered>
      <Modal.Header closeButton>
        <Modal.Title>Substitutes for {identifier}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Messages messages={messages} />
        <div id="search-table"className={classnames("table-responsive mt-2", {
            "custom-height": substitutes.length > 7,
          })}>
          <h4 className="fw-normal mb-0">Possible Substitutes</h4>
          <small>Showing only parts with available stock and price</small>
          <table className="table table-bordered mt-2">
            <thead className="table-light border-dark">
              <tr>
                <th className="mfg-part-number">Manufacturer Part Number</th>
                <th className="vendor-part-number">Vendor Part</th>
                <th className="description">Description</th>
                <th className="unit-price text-end">Unit Price</th>
                <th className="selection"></th>
              </tr>
            </thead>
            <tbody>
              {loading && 
                <tr>
                  <td colSpan="4" className="text-center">
                    Searching substitutes
                  </td>
                </tr>
              }
              {!loading && (!substitutes || (substitutes && substitutes.length == 0)) && 
                <tr>
                  <td colSpan="4" className="text-center">
                    No substitutes found
                  </td>
                </tr>
              }
              {!loading && substitutes && substitutes.length > 0 && substitutes.map((substitute, index) => (
                <Substitute 
                  key={`substitute-${index}`} 
                  exact_qty={exact_qty}
                  markup={selected_markup}
                  selected_board_qty={selected_board_qty}
                  selected_ps={selected_ps}
                  substitute={substitute}
                  onReplacePartSupplier={onReplacePartSupplier}/>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row">
          <div className='col-5'></div>
          <div className='col-6 d-flex justify-content-end'>
            { loading && 
              <button type="button" 
                className="btn btn-outline-primary" 
                disabled>
                Loading...
              </button>
            }
            { !loading &&
              <>
                <button type="button" 
                  className="btn btn-outline-primary" 
                  onClick={onHide}>
                  CANCEL
                </button>
              </>
            }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ShowMoreOptions;